module.exports = __webpack_public_path__ + "static/media/007.32e3de7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/007.jpg
// module id = 354
// module chunks = 0